import createStandardI18nProvider, {
  StandardI18nProviderOptions,
  StandardI18nProvider,
} from './createStandardI18nProvider';
import { defaultLanguage } from '../internal/legacyI18nInit';
import { PUBLIC_CACHE } from '../internal/localeCacheKeys';

export interface PublicI18nProviderOptions extends StandardI18nProviderOptions {
  manuallySetLocale?: boolean;
}

export type PublicI18nProvider = StandardI18nProvider;

export default (options?: PublicI18nProviderOptions): PublicI18nProvider => {
  const I18nProvider = createStandardI18nProvider({
    ...options,
    __localesCacheKey: PUBLIC_CACHE,
  });

  if (!options || (options && !options.manuallySetLocale)) {
    let browserLocale = defaultLanguage;
    if (navigator && navigator.languages && navigator.languages[0]) {
      browserLocale = navigator.languages[0];
    } else if (navigator && navigator.language) {
      browserLocale = navigator.language;
    }

    I18nProvider.setLocale({
      locale: browserLocale,
      langEnabled: true,
    });
  }

  return I18nProvider;
};
